import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Package, LogOut, Sparkles, User as UserIcon } from "lucide-react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const STATUS_ES = { paid: "Pagado", pending: "Pendiente", cancelled: "Cancelado" };

export default function Account() {
  const { user, loading, logout } = useAuth();
  const nav = useNavigate();
  const [orders, setOrders] = useState([]);

  useEffect(() => {
    if (!loading && !user) nav("/entrar");
    if (user) api.get("/orders/mine").then((r) => setOrders(r.data)).catch(() => {});
  }, [user, loading, nav]);

  if (!user) return null;

  return (
    <div className="max-w-4xl mx-auto px-4 py-10">
      <div className="bg-white border rounded-2xl p-6 flex items-center gap-4">
        <div className="w-16 h-16 rounded-full bg-drelo-primary/10 grid place-items-center"><UserIcon className="w-8 h-8 text-drelo-primary" /></div>
        <div className="flex-1">
          <h1 className="font-display font-black text-2xl">{user.name}</h1>
          <p className="text-drelo-muted text-sm">{user.email}</p>
        </div>
        <button onClick={() => { logout(); nav("/"); }} className="flex items-center gap-1.5 text-sm font-bold text-drelo-urgency" data-testid="account-logout"><LogOut className="w-4 h-4" /> Salir</button>
      </div>

      <div className="grid sm:grid-cols-3 gap-3 mt-4">
        <Link to="/embajadores" className="bg-gradient-to-r from-drelo-primary to-drelo-deal text-white rounded-2xl p-5 sm:col-span-3 flex items-center gap-3">
          <Sparkles className="w-8 h-8" />
          <div className="flex-1">
            <p className="font-bold">Código de embajador: <span className="font-display font-black">{user.referral_code}</span></p>
            <p className="text-sm text-white/90">Créditos: ${user.credits?.toFixed(2)} · {user.referrals_count} referidos</p>
          </div>
          <span className="bg-white text-drelo-ink font-black px-4 py-2 rounded-full text-sm">Ver panel →</span>
        </Link>
      </div>

      <h2 className="font-display font-black text-xl uppercase tracking-tight mt-8 mb-3 flex items-center gap-2"><Package className="w-5 h-5" /> Mis pedidos</h2>
      {orders.length === 0 ? (
        <div className="bg-white border rounded-2xl p-8 text-center text-drelo-muted">
          Aún no tienes pedidos. <Link to="/tienda" className="text-drelo-primary font-bold">¡Explora la tienda!</Link>
        </div>
      ) : (
        <div className="space-y-3">
          {orders.map((o) => (
            <div key={o.id} className="bg-white border rounded-2xl p-4" data-testid={`order-${o.id}`}>
              <div className="flex justify-between items-center">
                <div>
                  <span className="font-mono font-bold text-sm">#{o.id.slice(0, 8)}</span>
                  <span className={`ml-2 text-xs font-bold px-2 py-0.5 rounded-full ${o.payment_status === "paid" ? "bg-green-100 text-drelo-mint" : "bg-amber-100 text-amber-700"}`}>{STATUS_ES[o.payment_status] || o.payment_status}</span>
                </div>
                <span className="font-display font-black text-drelo-primary">${o.total.toFixed(2)}</span>
              </div>
              <div className="flex gap-2 mt-3 overflow-x-auto">
                {o.items.map((it, i) => <img key={i} src={it.image} alt={it.title} className="w-12 h-12 rounded-lg object-cover border shrink-0" />)}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
